import React from 'react';
import { FullScreenHandle } from 'react-full-screen';
import styled from 'styled-components';
import { SortTypes } from '../../../../../../types';
import { BarChartLayouts, ChartDisplayConfig } from '../common-chart-types';
import { ChartExport } from './tool-components/ChartExportMenu';
import { DisplayLabelsToggle } from './tool-components/DisplayLabelsToggle';
import { DisplayLegendToggle } from './tool-components/DisplayLegendToggle';
import { DisplayPercentageToggle } from './tool-components/DisplayPercentageToggle';
import { DisplayStackToggle } from './tool-components/DisplayStackToggle';
import { FullScreenToggle } from './tool-components/FullScreenToggle';
import { SortOrderToggle } from './tool-components/SortOrderToggle';
import { TableViewToggle } from './tool-components/TableViewToggle';
import { WrappedXAxisLabelsToggle } from './tool-components/WrappedXAxisLabelsToggle';

interface ChartToolsProps {
  fullScreenHandle: FullScreenHandle;
  chartRef: React.RefObject<HTMLElement>;
  displayConfig: ChartDisplayConfig;
}

const StyledTools = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  z-index: 1000;
`;

export const ChartTools = (props: ChartToolsProps) => {
  const { fullScreenHandle, chartRef, displayConfig } = props;
  const {
    enableLabels = false,
    showLabels = false,
    enablePercentage = false,
    enableStack = false,
    enableLegend = false,
    showLegend = false,
    enableSortOrder = false,
    selectedSortOrder = SortTypes.ASC,
    enableTableView = false,
    showTableView = false,
    showGridLines = false,
    enableWrappedXAxisLabels = false,
    layout = BarChartLayouts.GROUPED,
    onClickPercentage,
    onClickStack,
    onClickLabels,
    onClickLegend,
    onSelectSortOrder,
    onClickTableView,
    onClickFullScreen,
    onClickWrappedXAxisLabels,
    enableExport = true,
  } = displayConfig;
  const showChartExport = !showTableView;
  const showPercentage = layout === BarChartLayouts.PERCENTAGE;
  const showStack = layout === BarChartLayouts.STACKED;
  return (
    <StyledTools>
      {enablePercentage && !showStack ? (
        <DisplayPercentageToggle onClick={() => onClickPercentage?.()} />
      ) : null}
      {enableStack && !showTableView && !showPercentage ? (
        <DisplayStackToggle
          showStack={showStack}
          onClick={() => onClickStack?.()}
        />
      ) : null}
      {enableLabels && !showTableView ? (
        <DisplayLabelsToggle onClick={() => onClickLabels?.()} />
      ) : null}
      {enableLegend && !showTableView ? (
        <DisplayLegendToggle onClick={() => onClickLegend?.()} />
      ) : null}
      {enableWrappedXAxisLabels &&
      onClickWrappedXAxisLabels &&
      !showTableView ? (
        <WrappedXAxisLabelsToggle onClick={() => onClickWrappedXAxisLabels()} />
      ) : null}
      {enableSortOrder ? (
        <SortOrderToggle
          selectedSortOrder={selectedSortOrder}
          onSortOrderChange={(sortOrder) => onSelectSortOrder?.(sortOrder)}
        />
      ) : null}
      {enableExport && showChartExport && <ChartExport chartRef={chartRef} />}
      {fullScreenHandle.active ? null : (
        <FullScreenToggle fullScreenHandle={fullScreenHandle} />
      )}
      {enableTableView ? (
        <TableViewToggle
          showTableView={showTableView}
          onClick={() => onClickTableView?.()}
        />
      ) : null}
    </StyledTools>
  );
};
